import { api } from "../configs/axiosConfigs";

const trackContractorReferral = async (data) => {
  const response = await api.request({
    url: "api/contractor-referral/track",
    method: "POST",
    data,
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

const attachContractorRegistration = async (data) => {
  const response = await api.request({
    url: "api/contractor-referral/attach-registration",
    method: "POST",
    data,
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

const ContractorReferralApi = {
  trackContractorReferral,
  attachContractorRegistration,
};

export default ContractorReferralApi;
